// extracted by mini-css-extract-plugin
export default {"overlay":"uB-z","bodyOpen":"vB-z","content":"wB-z","header":"xB-z","close":"yB-z","closeNoHeading":"zB-z"};